import { assert } from "./assert.js";
export const DEFAULT_MIN_SCHEDULE_TRIGGER_INTERVAL = 60;
export const DEFAULT_ENTITLEMENTS = {
    users: 3,
    apiRequests: 10000,
    apiRateLimit: 5,
    contentEntries: 500,
    roles: 5,
    workflows: 0,
    locales: 2,
    webhooks: true,
    providers: [],
    importFromCSV: false,
    minScheduleTriggerInterval: DEFAULT_MIN_SCHEDULE_TRIGGER_INTERVAL,
    bandwidth: 5,
    apiCdn: false,
    guards: 0,
    staticSites: 0
};
export function isStripeProductObject(product) {
    return Boolean(product && typeof product !== 'string' && product.object === 'product' && !product.deleted);
}
export function getStripeProductObject(product) {
    assert(isStripeProductObject(product), 'product is not a Stripe product object');
    return product;
}
export function isStripeChargeObject(charge) {
    return typeof charge !== 'string';
}
